<template>
  <div class="" id="page-users">
    <h5 class="m-4 page-header"> >> Web Builder Test Page</h5>

    <memlist-card>
      <WebBuilderExample />
    </memlist-card>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import WebBuilderExample from '@/view/components/web_builder/WebBuilderExample.vue';

export default {
  name: 'WebBuilderTextPage',
  components: {
    WebBuilderExample,
  },
  mixins: [ toasts ],
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods', 'sid', 'isTHS'])
  },
  async mounted() {

  },
  data() {
    return {

      
    };
  },
  watch: {
    currentCompanyId(newValue, oldvalue) {
      if (newValue) {

      }
    },

  },
  methods: {

  }
};
</script>
<style scoped lang="scss"></style>
